import React from 'react';
import { useQueryClient } from 'react-query';
import { Empty } from 'antd';
import cn from 'classnames';
import useCompanyServicesUsed from '../../../../../hooks/useCompanyservicesUsed';
import InnerCard from '../../../../../components/InnerCard/InnerCard';
import InfoBlock from '../../../../../components/InfoBlock/InfoBlock';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import { CardChangeButton } from '../../../../../../../components/Card';
import ChangeRoomServicesModal from '../../../../../components/modals/ChangeRoomServicesModal/ChangeRoomServicesModal';
import commonStyles from '../../../AboutRoom.module.scss';
import styles from '../RoomBlock.module.scss';

const Services = ({ room }) => {
  const services = useCompanyServicesUsed(room);

  const { visible, showModal, hideModal } = useChangeModalVisible();

  return (
    <InnerCard
      title="Услуги"
      action={
        <CardChangeButton
          text={
            room.companyServices.some((service) => service.isUse)
              ? 'Изменить'
              : 'Добавить'
          }
          className={commonStyles.innerCardAction}
          onClick={showModal}
        />
      }
    >
      {Boolean(services.length) ? (
        services.map((service) => (
          <InfoBlock key={service.id}>
            <p className={cn(styles.text, styles.mainText)}>
              {service.name ?? '-'}
            </p>
          </InfoBlock>
        ))
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
      <ChangeRoomServicesModal
        visible={visible}
        onCancel={hideModal}
        room={room}
      />
    </InnerCard>
  );
};

export default Services;
